import React from "react";
import { T } from "../../app/tokens.js";
import { PROJECT_STAGES } from "../../lib/projectStage.js";

export function ProjectStagePill({ stage }) {
  return <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: 6,
    fontSize: T.fsXs, fontWeight: T.fwSemibold,
    color: stage === "on_hold" ? T.amber : stage === "intake" ? T.blue : T.mid,
    background: stage === "on_hold" ? T.utilAmber : T.lightGray }}>
    {PROJECT_STAGES[stage] || "Stage unknown"}
  </span>;
}

export function ProjectStageControl({ stage, completedOn, note, onChange, disabled = false }) {
  return <fieldset disabled={disabled} style={{ border: 0, padding: 0, margin: "12px 0" }}>
    <legend style={{ color: T.mid, fontSize: T.fsXs, fontWeight: T.fwBold }}>Stage</legend>
    <div role="group" aria-label="Project Stage" style={{ display: "flex", gap: 4, flexWrap: "wrap", marginTop: 6 }}>
      {Object.entries(PROJECT_STAGES).map(([value, label]) => <button key={value} type="button"
        aria-pressed={stage === value} onClick={() => onChange("stage", value)}
        style={{ border: `1px solid ${T.border}`, borderRadius: 7, padding: "5px 9px", fontFamily: "inherit",
          background: stage === value ? T.projectsHubNavy : T.card, color: stage === value ? T.white : T.mid, cursor: "pointer" }}>
        {label}
      </button>)}
    </div>
    {stage === "completed" && <label style={{ display: "block", marginTop: 10 }}>Completed on
      <input aria-label="Completed on" type="date" value={completedOn || ""} onChange={e => onChange("completedOn", e.target.value)}
        style={{ display: "block", border: `1px solid ${T.border}`, borderRadius: 6, padding: 6, color: T.dark }} />
    </label>}
    <label style={{ display: "block", marginTop: 10 }}>Transition note (optional)
      <input aria-label="Transition note (optional)" value={note || ""} onChange={e => onChange("stageNote", e.target.value)}
        style={{ display: "block", width: "100%", boxSizing: "border-box", border: `1px solid ${T.border}`, borderRadius: 6, padding: 6 }} />
    </label>
  </fieldset>;
}
